module.exports = __webpack_public_path__ + "static/img/4.38bf7f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/5/4.png
// module id = 248
// module chunks = 0